/**
 * QL-283 — the ONE badge for an order's direction (Buy / Sell / Keep /
 * Switch), shared by the client Orders tab, the order detail dialog and the
 * custom-portfolio builder's Direction column. Variant mapping and labels
 * live here so a new order type is added once, not per surface.
 */

export const T = {
  en_GB: { type: { buy: "Buy", sell: "Sell", keep: "Keep", switch: "Switch" } },
  nb_NO: { type: { buy: "Kjøp", sell: "Salg", keep: "Behold", switch: "Bytte" } },
} as const;
